import React from "react";
import "../../../styles/vipcode.css";
import { clientCodeIcon, clientDotIcon } from "../../../image/icons";

const VipCodeHeader = (logic) => {


  const handleClientCodeClick = () => {
    if (logic.offerLoaded) return;
    logic.onScanNew();
  };


  return (
    <div className="vip-header">
      <div className="vip-header__badge vip-header__badge--code" onClick={handleClientCodeClick}>
        <span className="vip-header__badge-icon">
          {clientCodeIcon()}
        </span>
        <span className="vip-header__badge-text">
          {logic.offerLoaded ? `Client code: ${logic.vipCode}` : "Scan client code"}
        </span>
      </div>

      <div className="vip-header__badge vip-header__badge--merchant">
        <span className="vip-header__badge-icon">
          {clientDotIcon()}
        </span>
        <span className="vip-header__badge-text">{logic.merchantName}</span>
      </div>
    </div>
  );
};

export default VipCodeHeader;
